import HomePage from './HomePage.jsx';

export default HomePage;
